import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  isLoading$ = new BehaviorSubject<boolean>(false);
  isLoading = this.isLoading$.asObservable();

  loaderText$ = new BehaviorSubject<string>('');
  loaderText = this.loaderText$.asObservable();

  constructor() { }

  setLoader(text:string) {
    this.loaderText$.next(text);
    this.isLoading$.next(true);
  }
  hideLoader() {
    this.isLoading$.next(false);
  }
 }
